import * as Dialog from "@radix-ui/react-dialog";
import { QrCodeBarCodeProps } from "@on-site/components/pages/default/ui/QrCodeBarCode/type";
import { Button, Typography } from "@fanka/ui-admin";
import { QRCodeSVG } from "qrcode.react";

export const QrCodeBarCode = ({ text, open, onClose }: QrCodeBarCodeProps) => {
  return (
    <Dialog.Root open={open} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-opacity-50" style={{ backgroundColor: "white" }} />
        <Dialog.Content className="fixed inset-0 flex items-center justify-center">
          <div className="fixed inset-0 flex items-center justify-center overflow-hidden">
            <div className="flex h-full w-full max-w-lg flex-col items-center justify-center gap-y-16 rounded-md bg-white p-8">
              <div className="whitespace-pre-wrap text-center">
                <Typography.Heading type="h1">{`QRコードを読み込み、Web受付に\n進んでください`}</Typography.Heading>
              </div>
              <div className="flex flex-col gap-y-2">
                <QRCodeSVG value={text} width={280} height={264} />
              </div>
              <div className="mx-auto flex w-full max-w-[450px] flex-col items-center justify-center gap-y-2">
                <div className="flex w-full flex-col gap-y-4">
                  <Button size="lg" block onClick={onClose}>
                    最初の画面へ
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
